import { current } from "@reduxjs/toolkit";
import axios from "axios";

const checkAuth = () => {
  const TOKEN = localStorage.getItem("token");
  const PUBLIC_ROUTES = [
    "login",
   "add-licence"
  ];

  const isPublicPage = PUBLIC_ROUTES.some((r) =>
    window.location.href.includes(r)
  );

  if (!TOKEN && !isPublicPage) {
    window.location.href = "/login";
    return;
  } else {
    axios.defaults.headers.common["Authorization"] = `Bearer ${TOKEN}`;

    axios.interceptors.request.use(
      function (config) {
        document.body.classList.add("loading-indicator");
        return config;
      },
      function (error) {
        return Promise.reject(error);
      }
    );

    axios.interceptors.response.use(
      function (response) {
        document.body.classList.remove("loading-indicator");
        return response;
      },
      function (error) {
        document.body.classList.remove("loading-indicator");
        if (error.response && error.response.status === 401) {
          // Redirect to logout on 401 status code
          // Check if the current URL is NOT the login page
          const currentUrl = window.location.href;
          if (!currentUrl.includes("/login")) {
            localStorage.removeItem("token");
            window.location.href = "/login";
          }
        }
        return Promise.reject(error);
      }
    );
//     if (window.location.href.includes("login")){
// window.location.href ="/app/devices"
//     }
    
    return TOKEN;
  }
};

export default checkAuth;
